module.exports = __webpack_public_path__ + "img/edit_icon.34a3ccea.png";